import { Components } from 'src/components';
import { setComponentAttributes } from 'shared/storybook-utils';
export default {
  title: 'Components/Divider',
  component: 'a1-divider',
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component: 'Content Component - Used for section divider.',
      },
    },
    layout: 'centered',
  },
};

const elementName = 'a1-divider';

const Template = (args: Components.A1Divider): HTMLElement => {
  const elComponent = document.createElement(elementName);

  Object.entries(args).forEach(([key, value]) => {
    setComponentAttributes({ element: elComponent, key, value });
  });
  return elComponent;
};

export const Default: Story<Components.A1Divider> = Template.bind({});
